/* @flow weak */
import { range as lrange } from 'lodash';
import FormSelect from 'components/FormSelect.jsx';
import React from 'react';

const currentYear = new Date().getFullYear();
const computeRange = (from, to) => lrange(from, to + 1).map(
  number => {
    return { value: number, label: number.toString() };
  }
);

const dayRange = computeRange(1, 31);
const monthRange = computeRange(1, 12);
const yearRange = computeRange(currentYear - 100, currentYear).reverse();

const FormDaySelect = props => <FormSelect {...props} options={dayRange} />;
const FormMonthSelect = props => <FormSelect {...props} options={monthRange} />;
const FormYearSelect = props => <FormSelect {...props} options={yearRange} />;

export { FormDaySelect, FormMonthSelect, FormYearSelect };



// WEBPACK FOOTER //
// ./src/components/FormDateInputs.jsx